import { useRef } from 'react';

// material-ui
import { Grid } from '@mui/material';
import { Outlet } from 'react-router';
import Container from '@mui/material/Container';

// project import
import ProfileCard from '../../sections/apps/profiles/user/ProfileCard';
import ProfileTabs from "../../sections/apps/profiles/user/ProfileTabs";

const UserProfile = () => {
    const inputRef = useRef(null);
    const focusInput = () => {
        inputRef.current?.focus();
    };

    return (
        <Container maxWidth="lg" sx={{paddingTop: '10%'}}>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <ProfileCard focusInput={focusInput} />
            </Grid>
            <Grid item xs={12} md={3}>
                <ProfileTabs focusInput={focusInput} />
            </Grid>
            <Grid item xs={12} md={9}>
                <Outlet context={inputRef} />
            </Grid>
        </Grid>
        </Container>
    );
}
  export default UserProfile;